/**
 * Masks a VKN (10 digits) or TCKN (11 digits) for listings: only the first 3
 * and the last 3 characters stay visible ("123****890"), the same format the
 * backend uses for the buyer tax id of an order document ("179*****032").
 *
 * Anything of 6 characters or fewer cannot be partially shown without
 * revealing the whole number, so it is fully masked.
 */
export const maskTaxId = (taxId?: string | number | null): string => {
  if (taxId === null || taxId === undefined) return '';
  const value = String(taxId).trim();
  if (value.length === 0) return '';
  if (value.length <= 6) return '*'.repeat(value.length);
  return `${value.slice(0, 3)}${'*'.repeat(value.length - 6)}${value.slice(-3)}`;
};
